import { Component, ViewChild, signal, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { ClientListComponent } from '../matwins-manager/client/client-list/client-list.component';
import { PointOfServiceListComponent } from '../matwins-tenant/point-of-service/pos-list/point-of-service-list.component';
import { Client } from '@app/common-codes/models/matwins-manager/Client.model';
import { PointOfService } from '@app/common-codes/models/matwins-tenant/PointOfService.model';

import { Tenant } from '@app/common-codes/models/matwins-tenant/Tenant.model';
import { CurrentTenantService } from '@app/common-codes/services/CurrentTenantService';
import { Dock } from '@app/common-codes/models/matwins-tenant/Dock.model';
import { Trucker } from '@app/common-codes/models/matwins-tenant/Trucker.model';
import { TruckerActivity } from '@app/common-codes/models/matwins-tenant/TruckerActivity.model';
import { DockListComponent } from '../matwins-tenant/dock/dock-list/dock-list.component';
import { TruckerListComponent } from '../matwins-tenant/trucker/trucker-list/trucker-list.component';
import { TruckerActivityListComponent } from '../matwins-tenant/trucker-activity/activity-list/trucker-activity-list.component';
import { MatwinsVariablesService } from '@app/common-codes/services/matwinsVariables.service';
import { LookupProfile } from '@app/common-codes/services/LookupService';
import { FilterStateService } from '@app/common-codes/services/FilterStateService';
import { TranslatePipe } from '@app/common-codes/components/directives/TranslatePipe';


@Component({
  selector: 'app-home',
  imports: [ClientListComponent, PointOfServiceListComponent, DockListComponent, TruckerListComponent, TruckerActivityListComponent, TranslatePipe],
  templateUrl: './home.component.html',
  styleUrl: './home.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class HomeComponent {
  @ViewChild(ClientListComponent) clientListComponent!: ClientListComponent;

  selectedClient = signal<Client | null>(null);
  pointOfServices = signal<PointOfService[] | null>([]);
  selectedPointOfService = signal<PointOfService | null>(null);
  docks = signal<Dock[] | null>(null);
  truckers = signal<Trucker[] | null>(null);
  truckerActivities = signal<TruckerActivity[] | null>(null);

  constructor(
    private cdr: ChangeDetectorRef,
    private currentTenantService: CurrentTenantService,
    private matwinsVariables: MatwinsVariablesService,
    private filterStateService: FilterStateService
  ) { }

  // Remet a zero les filtres de toutes les listes de la vue, en un clic.
  clearAllFilters(): void {
    this.filterStateService.clearAll();
  }



  onClientSelected(client: Client | null) {
    this.selectedClient.set(client);
    this.currentTenantService.currentTenant.set(client?.relatedTenant ?? null); // Setter le tenant actuel dans le service

    // Sans cela les listes imbriquees de cette vue n'ont pas de client a interroger, et leur
    // verification passe silencieusement a la trappe.
    this.matwinsVariables.setClientId(client?.id || null);

    // Mise a jour de la variable d'application
    const prefix = client?.relatedTenant?.prefix ?? '';
    this.matwinsVariables.tenantPrefix = prefix.replace('https://','').split('.')[0];
    this.matwinsVariables.tenantPrefixChanged$.set(prefix); 

    this.selectedPointOfService.set(null); // Reset selected PointOfService

    if (client?.relatedTenant) {
      if (!client.relatedTenant.pointOfServices)
        client.relatedTenant.pointOfServices = [];

      if (client && client.relatedTenant && client.relatedTenant.pointOfServices) {
        client.relatedTenant.pointOfServices.forEach(pos => {
          pos.sourceTenantDTO = structuredClone(client.relatedTenant);
          (pos.sourceTenantDTO as any).pointOfServices = [];
        });

        this.pointOfServices.set(client.relatedTenant.pointOfServices);

        // Initialize docks, truckers, and truckerActivities from all pointOfServices
        const allDocks: Dock[] = [];
        const allTruckers: Trucker[] = [];
        const allTruckerActivities: TruckerActivity[] = [];

        client.relatedTenant.pointOfServices.forEach(pos => {
          if (pos.docks) allDocks.push(...pos.docks);
          if (pos.truckers) allTruckers.push(...pos.truckers);
          if (pos.truckerActivities) allTruckerActivities.push(...pos.truckerActivities);
        });

        this.docks.set(allDocks);
        this.truckers.set(allTruckers);
        this.truckerActivities.set(allTruckerActivities);

      } else {
        this.pointOfServices.set([]);
        this.docks.set([]);
        this.truckers.set([]);
        this.truckerActivities.set([]);
      }
    } else {
      this.pointOfServices.set([]);
      this.docks.set([]);
      this.truckers.set([]);
      this.truckerActivities.set([]);
    }

    this.cdr.detectChanges();
  }

  onPointOfServiceSelected(pos: PointOfService | null) {
    this.selectedPointOfService.set(pos);

    if (pos) {
      this.docks.set(pos.docks || []);
      this.truckers.set(pos.truckers || []);
      this.truckerActivities.set(pos.truckerActivities || []);

      // prepare all required lookups
      //let dataService = 


    } else {
    
      const allDocks: Dock[] = [];
      const allTruckers: Trucker[] = [];
      const allTruckerActivities: TruckerActivity[] = [];

      this.pointOfServices()?.forEach(p => {
        if (p.docks) allDocks.push(...p.docks);
        if (p.truckers) allTruckers.push(...p.truckers);
        if (p.truckerActivities) allTruckerActivities.push(...p.truckerActivities);
      });

      this.docks.set(allDocks);
      this.truckers.set(allTruckers);
      this.truckerActivities.set(allTruckerActivities);
    }
    this.cdr.detectChanges();
  }



}

